<template>
    <div class="text-base text-black dark:text-white dark:bg-slate-900 layout_landing" :class="current_mode"
        :dir="$page.props.dir">
        <!-- Start Navbar -->
        <top-nav />
        <!-- End Navbar -->

        <!--success message -->
        <flash-messages />
        <!--success message -->

        <!--main content-->
        <slot />
        <!--main content-->
        <!-- footer -->
        <footer-section :footer="footer" />
        <!-- footer -->

        <!-- Back To Top Start -->
        <a id="back-to-top" @click="topFunction" href="javascript:void(0)"
            class="back-to-top flex fixed hidden bottom-5 right-5 left-auto z-[999] h-10 w-10 items-center justify-center rounded-md bg-primary text-white shadow-md transition duration-300 ease-in-out hover:bg-dark">
            <span class="mt-[6px] h-3 w-3 rotate-45 border-t border-l border-white"></span>
        </a>
        <!-- Back To Top End -->

        <!-- Public Chat -->
        <div class="chat_public" v-if="!!this.enable_option && this.enable_option.chat">
            <div v-if="!!open_chat && !!current_chat" class="chat__box">
                <div class="flex justify-center items-center ">
                    <div class="w-80 h-96 bg-white rounded shadow-2xl">
                        <nav class="w-full bg-gray-900 rounded-tr rounded-tl flex justify-between items-center p-2">
                            <div class="flex justify-center items-center w-full">
                                <Logo class="block h-10 fill-white" height="40" />
                            </div>
                            <div class="flex items-center space-x-2">
                                <button @click="exitChat" class="text-gray-300 hover:text-white focus:outline-none flex items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clip-rule="evenodd" />
                                    </svg>
                                    <span class="ml-1 text-sm">Exit</span>
                                </button>
                                <!-- <button @click="toggleChat" class="text-gray-300 hover:text-white focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                                    </svg>
                                </button> -->

                            </div>
                        </nav>
                        <div class="overflow-auto px-1 py-1 reverse__order" style="height: 19rem;" id="journal-scroll">
                            <div v-if="current_chat.messages && current_chat.messages.length"
                                v-for="(message, index) in current_chat.messages.slice().reverse()" :key="index"
                                class="flex items-end pr-4 mt-4"
                                v-bind:class="{ 'pt-3 pl-10 justify-end': !!message.contact_id }">
                                <img v-if="message.user_id && current_chat.participant.user"
                                    src="/images/svg/profile.svg"
                                    class="rounded-full shadow-xl object-cover w-12 h-12" />

                                <span v-if="message.contact_id" class="text-gray-400 pr-1 f-time pb-1">{{
                                    moment(message.updated_at).format('h:mma') }}</span>
                                <span
                                    class="flex h-auto text-gray-200 text-md font-normal rounded-sm px-1 p-1 items-end agent_text"
                                    v-bind:class="{ 'ml-1 bg-gray-900 dark:bg-slate-800': !!message.user_id, 'bg-green-900': !!message.contact_id }">
                                    {{ message.message }}
                                </span>
                                <span v-if="message.user_id" class="text-gray-400 pl-1 f-time pb-1">{{
                                    moment(message.updated_at).format('h:mma') }}</span>
                            </div>
                        </div>
                        <div class="flex justify-between items-center p-1 bg-white chat_b_footer">
                            <div class="relative t__area">
                                <input v-model="message" @keydown.enter.exact.prevent="sendMessage" type="text"
                                    class="pl-3 pr-3 py-2 focus:outline-none h-12 border-gray-100 w-full"
                                    placeholder="Type and press [enter].." id="typemsg">
                                <!-- <button class="absolute right-8 top-1 transform -rotate-45 text-gray-400 focus:outline-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                        <path fill-rule="evenodd" d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z" clip-rule="evenodd" />
                                    </svg>
                                </button> -->
                            </div>
                            <div class="w-8 h-8 rounded-full text-center items-center flex justify-center">
                                <button
                                    class="w-8 h-8 rounded-full text-center items-center flex justify-center focus:outline-none bg-gray-700 text-white p-2"
                                    @click="sendMessage">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 252.07 169.78"
                                        fill="currentcolor">
                                        <g id="Layer_2" data-name="Layer 2">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <polygon
                                                    points="0 0 0 69.91 142.84 84.89 0 99.88 0 169.78 252.07 84.89 0 0" />
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!!open_chat && !current_chat" class="init_chat">
                <div class="flex justify-center items-center ">
                    <div class="w-80 h-auto bg-white rounded shadow-2xl">
                        <nav class="w-full bg-gray-900 rounded-t flex flex-col items-center pt-3">
                            <Logo class="block mx-auto w-full max-w-xs fill-white" height="40" />
                            <p class="text-md font-medium text-gray-300 text-center p-3 mb-3 t_h_text">Let us know who
                                you are, and let's get talking.</p>
                        </nav>
                        <div class="overflow-auto">
                            <div class="flex items-center">
                                <div class="w-full">
                                    <form class="bg-white rounded px-8 pt-6 pb-8">
                                        <div class="flex justify-center mb-4">
                                            <div class="flex flex-col pr-2">
                                                <label class="block text-gray-700 text-xs font-bold mb-2"
                                                    for="firstName">
                                                    {{ __('First name') }}
                                                </label>
                                                <input v-model="init_user.firstName"
                                                    class=" appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                                                    id="firstName" type="text" :placeholder="__('First name')">
                                            </div>
                                            <div class="flex flex-col pl-2">
                                                <label class="block text-gray-700 text-xs font-bold mb-2"
                                                    for="lastName">
                                                    {{ __('Last name') }}
                                                </label>
                                                <input v-model="init_user.lastName"
                                                    class=" appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                                                    id="lastName" type="text" :placeholder="__('Last name')">
                                            </div>
                                        </div>
                                        <div class="mb-6">
                                            <label class="block text-gray-700 text-xs font-bold mb-2"
                                                for="emailAddress">
                                                {{ __('Email Address') }}
                                            </label>
                                            <input v-model="init_user.email"
                                                class=" appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                                                id="emailAddress" type="text" :placeholder="__('Email address')">
                                        </div>
                                        <div class="flex items-center justify-space-between">
                                            <button
                                                class="flex text-gray-300 bg-gray-900 font-bold pr-2 py-2 px-4 rounded focus:outline-none focus:shadow-outline btn_start_chat"
                                                type="button" @click="startChat">
                                                {{ __('Start Chat') }}
                                            </button>
                                            <button type="button" @click="toggleChat" class="flex text-red-600 bg-red-900 justify-between font-bold pr-2 py-2 px-2 rounded focus:outline-none focus:shadow-outline btn_end_chat">
                                                {{ __('Close') }}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="chat_bubble" @click="toggleChat">
                <span v-if="unread_count" class="notification_badge">1</span>
                <span class="chat__icn hover:scale-125 duration-300" v-if="!open_chat">
                    <img src="/images/logo.png" alt="Live Chat" />
                </span>
                <span class="chat__close hover:scale-125 duration-300" v-if="!!open_chat">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </span>
                <span class="bottom_text">let's talk</span>
            </button>

            <!-- Rating Modal -->
            <transition name="rating-modal">
                <div v-if="showRatingModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
                    <div class="bg-white rounded-lg p-6 w-80">
                        <h3 class="text-lg font-medium mb-4">Rate your chat experience</h3>

                        <div class="flex justify-center mb-4">
                            <button v-for="star in 5" :key="star"
                                @click="setRating(star)"
                                class="text-2xl focus:outline-none transform hover:scale-125 transition-transform duration-150"
                                :class="{'text-yellow-400': star <= rating, 'text-gray-300': star > rating}">
                                ★
                            </button>
                        </div>

                        <textarea v-model="ratingComment"
                            class="w-full border rounded p-2 mb-4"
                            placeholder="Any additional comments..."></textarea>

                        <div class="flex justify-end space-x-2">
                            <button @click="skipRating"
                                class="px-4 py-2 text-gray-600 hover:text-gray-800">
                                Skip
                            </button>
                         <button @click="submitRating"
                            class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 rating-submit-btn"
                            :disabled="rating === 0">
                            Submit
                        </button>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!-- Public Chat -->

        <span class="disabled_button"></span>

        <!-- Color Picker -->
        <div v-if="!!this.enable_option && this.enable_option.color_picker" id="color-switcher"
            @click="actionColorScheme($event)" data-expend="no"
            class="ease-in duration-300 shadow-sm fixed z-[999] top-[40%] right-[-154px] py-3 px-4 bg-white">
            <div
                class="shadow-sm absolute rounded-l-lg top-0 left-[-40px] w-10 h-10 bg-[#64748b] flex justify-center items-center scheme-button cursor-pointer">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
                </svg>
            </div>
            <h4 class="text-lg pb-1 border-b font-normal dark:text-black">Color Scheme</h4>
            <div class="pt-3 grid grid-cols-4 gap-x-1 gap-y-2">
                <div class="s_switch w-6 h-6 rounded-full bg-[#3470b9] cursor-pointer border border-transparent hover:border-[#3470b9]"
                    data-scheme="scheme-blue" @click="setColorScheme($event)"></div>
                <div class="s_switch w-6 h-6 rounded-full bg-[#14a44b] cursor-pointer border border-transparent hover:border-[#14a44b]"
                    data-scheme="scheme-green" @click="setColorScheme($event)"></div>
                <div class="s_switch w-6 h-6 rounded-full bg-[#fee106] cursor-pointer border border-transparent hover:border-[#fee106]"
                    data-scheme="scheme-yellow" @click="setColorScheme($event)"></div>
                <div class="s_switch w-6 h-6 rounded-full bg-[#f31e2b] cursor-pointer border border-transparent hover:border-[#f31e2b]"
                    data-scheme="scheme-red" @click="setColorScheme($event)"></div>
                <div class="s_switch w-6 h-6 rounded-full bg-[#1f191a] cursor-pointer border border-transparent hover:border-[#1f191a]"
                    data-scheme="scheme-dark" @click="setColorScheme($event)"></div>
            </div>
        </div>
        <!-- Color Picker -->
    </div>
</template>

<style scoped>
/* Chat bubble styles */
.chat_bubble {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    z-index: 999;
}

.chat_bubble:hover {
    transform: scale(1.1);
}

.btn_end_chat{
  margin-left: 2px;
  border-radius: 5px;
  overflow: hidden;
  font: inherit;
  text-transform: none;
  display: inline-block;
  box-sizing: border-box;
  padding: 0.5rem 1rem;
  vertical-align: middle;
  font-size: 14px;
  line-height: 1.5rem;
  text-align: center;
  text-decoration: none;
  color: #fff;
  width: 100%;
}

.notification_badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background: #ef4444;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

/* Rating modal transitions */
.rating-modal-enter-active,
.rating-modal-leave-active {
    transition: opacity 0.3s ease;
}

.rating-modal-enter-from,
.rating-modal-leave-to {
    opacity: 0;
}

/* Star rating hover effect */
button[class*="text-2xl"] {
    transition: color 0.2s ease;
}

/* Message scroll area */
.reverse__order {
    display: flex;
    flex-direction: column-reverse;
}
</style>

<script>
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import TopNav from '@/Shared/Landing/TopNav'
import FooterSection from '@/Shared/Landing/FooterSection'
import Switcher from '@/Shared/Landing/Switcher'
import { Link } from '@inertiajs/vue3'
import FlashMessages from '@/Shared/FlashMessages'
import moment from 'moment'
import axios from 'axios'
import { useForm } from '@inertiajs/vue3';

export default {
    components: {
        Icon,
        Logo,
        Link,
        TopNav,
        FooterSection,
        Switcher,
        FlashMessages,
    },
    props: {
        title: String,
        footer: Object,
    },
    setup() {
    const form = useForm({
        chat_id: null,
        rating: 0,
        comment: ''
    });

    return { form };
},
    data() {
        return {
            current_mode: 'light',
            current_dir: 'ltr',
            current_chat: null,
            open_chat: false,
            unread_count: 0,
            chat_id: 0,
            contact_id: 0,
            message: null,
            enable_option: { color_picker: false },
            init_user: {
                firstName: '',
                lastName: '',
                email: '',
            },
            showRatingModal: false,
            rating: 0,
            ratingComment: '',
        }
    },
    methods: {
        toggleChat() {
            this.open_chat = !this.open_chat
        },
       exitChat() {
    if (this.current_chat?.id && this.current_chat?.messages?.length > 0) {
        this.showRatingModal = true;
    } else {
        this.clearChat();
    }
},
        setRating(star) {
            this.rating = star;
        },
async submitRating() {
    // Ensure we have the current chat ID
    if (!this.current_chat?.id) {
        this.$page.props.flash.error = 'No active conversation found';
        return;
    }

    // Prepare the form data
    const formData = {
        conversation_id: this.current_chat.id,
        rating: this.rating,
        comment: this.ratingComment
    };

    try {
        const response = await axios.post(this.route('chat.rating'), formData);

        if (response.data.success) {
            this.$page.props.flash.success = response.data.message || 'Thank you for your feedback!';
            this.closeRatingModal();
            this.clearChat();
        } else {
            this.$page.props.flash.error = response.data.message || 'Failed to submit rating';
        }
    } catch (error) {
        const errorMsg = error.response?.data?.message ||
                        error.message ||
                        'An error occurred while submitting your rating';
        this.$page.props.flash.error = errorMsg;
        console.error('Rating submission error:', error);
    }
},
        skipRating() {
            this.closeRatingModal();
            this.clearChat();
        },
        closeRatingModal() {
            this.showRatingModal = false;
            this.rating = 0;
            this.ratingComment = '';
        },
        hasCurrentChatMessage(message) {
            if (!this.current_chat || !Array.isArray(this.current_chat.messages)) {
                return false;
            }

            return this.current_chat.messages.some((existing) => {
                if (existing.id && message.id) {
                    return existing.id === message.id;
                }

                return (
                    existing.conversation_id === message.conversation_id &&
                    existing.contact_id === message.contact_id &&
                    existing.user_id === message.user_id &&
                    existing.message === message.message &&
                    (existing.updated_at || existing.created_at) === (message.updated_at || message.created_at)
                );
            });
        },
        appendCurrentChatMessage(message) {
            if (!message || this.hasCurrentChatMessage(message)) {
                return;
            }

            this.current_chat.messages.push(message);
        },
        clearChat() {
            this.current_chat = null;
            this.chat_id = 0;
            this.contact_id = 0;
            localStorage.removeItem('chat_id');
            localStorage.removeItem('contact_id');
            this.open_chat = false;
        },
        startChat() {
            if (!!this.init_user.email && !!this.init_user.firstName && !!this.init_user.lastName) {
                axios.post(this.route('chat.init'), this.init_user).then((response) => {
                    if (!!response.data && !!response.data.contact_id) {
                        this.current_chat = response.data
                        this.chat_id = this.current_chat.id
                        this.contact_id = this.current_chat.contact_id
                        localStorage.setItem('chat_id', this.chat_id)
                        localStorage.setItem('contact_id', this.contact_id)
                        this.watchMessage()
                    }
                }).catch((error) => {
                    console.log(error)
                })
            }
        },
        sendMessage() {
            const messageData = {
                message: this.message,
                contact_id: this.current_chat.contact_id,
                conversation_id: this.current_chat.id
            }
            this.message = ''
            axios.post(this.route('chat.send_message'), messageData).then((response) => {
                if (response.data) {
                    this.appendCurrentChatMessage(response.data)
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        watchMessage() {
            if (window.Echo) {
                window.Echo.channel(`chat.${this.chat_id}`).listen('NewPublicChatMessage', (e) => {
                    if (typeof e.chatMessage === 'object') {
                        this.appendCurrentChatMessage(e.chatMessage)
                    }
                })
            }
        },
        scrollFunction() {
            const mybutton = document.getElementById("back-to-top");
            if (mybutton) {
                if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                    mybutton.classList.add("block");
                    mybutton.classList.remove("hidden");
                } else {
                    mybutton.classList.add("hidden");
                    mybutton.classList.remove("block");
                }
            }
        },
        topFunction() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        switchMode() {
            this.current_mode = this.current_mode === 'light' ? 'dark' : 'light'
            localStorage.setItem('current_mode', this.current_mode)
            this.changeTheme();
        },
        changeTheme() {
            const htmlTag = document.getElementsByTagName("html")[0]
            htmlTag.className = this.current_mode;
        },
        changeDir() {
            const htmlTag = document.getElementsByTagName("html")[0]
            htmlTag.dir = this.current_dir;
        },
        actionColorScheme(e) {
            e.preventDefault()
            const that = e.currentTarget;
            const dataExpend = that.getAttribute('data-expend')
            if (dataExpend !== 'yes') {
                that.setAttribute('style', 'right:-10px !important');
                that.setAttribute('data-expend', 'yes');
            } else {
                that.setAttribute('style', 'right:-154px !important');
                that.setAttribute('data-expend', 'no');
            }
        },
        setColorScheme(e) {
            e.preventDefault()
            const color = e.currentTarget.getAttribute('data-scheme');
            const colors = ['scheme-indigo', 'scheme-orange', 'scheme-amber', 'scheme-yellow', 'scheme-lime', 'scheme-green', 'scheme-cyan', 'scheme-sky', 'scheme-violet', 'scheme-purple', 'scheme-fuchsia', 'scheme-pink', 'scheme-rose']
            document.getElementsByTagName("body")[0].classList.remove(...colors)
            document.getElementsByTagName("body")[0].classList.add(color)
            localStorage.setItem("scheme", color);
        },
        setColorSchemeFromStorage() {
            if (!!localStorage.getItem("scheme")) {
                const colors = ['scheme-indigo', 'scheme-orange', 'scheme-amber', 'scheme-yellow', 'scheme-lime', 'scheme-green', 'scheme-cyan', 'scheme-sky', 'scheme-violet', 'scheme-purple', 'scheme-fuchsia', 'scheme-pink', 'scheme-rose']
                document.getElementsByTagName("body")[0].classList.remove(...colors)
                document.getElementsByTagName("body")[0].classList.add(localStorage.getItem("scheme"))
            }
        },
    },
    mounted() {
        if (localStorage.getItem('chat_id')) {
            this.chat_id = localStorage.getItem('chat_id')
            this.contact_id = localStorage.getItem('contact_id')
            axios.get(this.route('chat.conversation', { id: this.chat_id, contact_id: this.contact_id })).then((res) => {
                if (res.data) {
                    this.current_chat = res.data
                    this.watchMessage()
                }
            })
        }
        window.addEventListener('scroll', this.scrollFunction);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.scrollFunction);
    },
    created() {
        this.setColorSchemeFromStorage();
        this.moment = moment;
        if (localStorage.getItem('current_dir')) {
            this.current_dir = localStorage.getItem('current_dir')
            this.changeDir();
        }
        if (this.$page.props.enable_options) {
            let options = JSON.parse(this.$page.props.enable_options.value)
            options.forEach(option => {
                this.enable_option[option.slug] = !!option.value
            })
        }
    }
}
</script>
